// Enabler E7-C (ADO-2274), D-1: what a catalogue screen shows when there is no active ordering
// entry. Every catalogue read names the entry (`catalogueEntry.ts`), so with none there is nothing
// to ask; the product page, the listing and search results, the mega-menu, the search typeahead,
// the RBP links page and the barcode scanner show this instead of a load that never starts.
//
// The words follow the header's depot tab, which says "Select a depot" while none is chosen
// (`SiteHeader`). The link leads to the choice screen and carries the page it was on as
// `returnTo`, so the choice screen comes back here once a depot is picked. A session whose
// choices read succeeded with no entries at all (an admin or a supplier user with no depots) gets
// the message without the link: the choice screen would only say there is nothing to order
// against. A failed choices read keeps the link, as the choice screen offers its retry.

import { Link, useLocation } from 'react-router';
import { useSessionStore } from '../auth/useSessionStore';
import linkButton from '../app/Cart/LinkButton.module.css';
import { CHOOSE_ROUTE } from './orderingChoices';
import styles from './NoEntryPrompt.module.css';

export const NO_ENTRY_MESSAGE = 'Select a depot to see products.';
export const NO_ENTRY_LINK_LABEL = 'Select a depot';

export interface NoEntryPromptProps {
  /** The host's own box (padding, alignment) around the message and the link. */
  readonly className?: string | undefined;
}

export function NoEntryPrompt({ className }: NoEntryPromptProps) {
  const location = useLocation();
  const canChoose = useSessionStore(
    (s) => s.orderingChoices === null || s.orderingChoices.entries.length > 0,
  );
  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  return (
    <div className={className === undefined ? styles.prompt : `${styles.prompt} ${className}`}>
      <p className={styles.message} role="status">
        {NO_ENTRY_MESSAGE}
      </p>
      {canChoose && (
        <Link
          to={CHOOSE_ROUTE}
          state={{ returnTo }}
          className={`${linkButton.linkButton} ${linkButton.secondary}`}
        >
          {NO_ENTRY_LINK_LABEL}
        </Link>
      )}
    </div>
  );
}
